import * as React from "react";
import { CheckmarkCircle, CrossCircle, Incorrect } from "../../assets/icons";
import { colourSemanticPositive, colourSemanticNegative, colourNeutral5 } from "@ingka/variables/colours-css";

interface TableCellProps {
	value: string | boolean;
}

const TableCell: React.FC<TableCellProps> = ({ value }) => {
	const stringValue = String(value).toLowerCase();

	switch (stringValue) {
		case "true":
			return (
				<CheckmarkCircle
					title="Enabled"
					role="img"
					ariaHidden={false}
					height={24}
					width={24}
					colour={colourSemanticPositive}
				/>
			);
		case "false":
			return (
				<CrossCircle
					title="Disabled"
					role="img"
					ariaHidden={false}
					height={24}
					width={24}
					colour={colourSemanticNegative}
				/>
			);
		case "undefined":
			return (
				<Incorrect title="Not launched" role="img" ariaHidden={false} height={24} width={24} colour={colourNeutral5} />
			);
		default:
			return <>{value}</>;
	}
};

export default TableCell;
